<template>
    <facility-and-project-main-container>
        <template #title>
            Project Admin
        </template>
        <template #controls>
            <create-new-button
                button-text="Create new project"
                library-name="Project"
                @onClick="newProject" />

            <div class="column is-one-third">
                <div
                    class="control has-icons-left">
                    <input
                        v-model="filter"
                        type="text"
                        class="input"
                        placeholder="Search by Name (minimum 3 characters)">
                    <span class="icon is-small is-left">
                        <i class="mdi mdi-magnify" />
                    </span>
                </div>
                <div style="color:#bababa;margin-top:8px;">
                    <i>Filter: {{ filterDisplayValue }}</i>
                </div>
                <b-message
                    type="is-warning"
                    has-icon
                    :model-value="showSearchHelpDialog">
                    Enter at least 3 characters into the search field to start displaying Projects.
                </b-message>
                <b-loading
                    v-model="loading"
                    :is-full-page="false"
                    :can-cancel="false" />
            </div>
        </template>
        <template #new>
            <router-view
                :code-set-name="codeSetName"
                title="Create a new project"
                library="Project"
                @onRefresh="refreshProjects"
                @onCancel="cancelNew" />
        </template>
        <template #projects>
            <project-virtual-list
                :rows="rows"
                :columns="columns"
                keyfield="id" />
        </template>
    </facility-and-project-main-container>
</template>

<script>
    import ProjectVirtualList from './ProjectVirtualList.vue';
    import { genericViewQueryAsText, getCodeSets } from '@/shared/helpers/api';
    import { requireCanEditCode } from '@/shared/directives/requirePermission';
    import { encodeIdBase64 } from '@/shared/helpers/utils';
    import ViewBaseFacilityAndProject from '@/apps/facilityAndProject/ViewBaseFacilityAndProject.vue';
    import CreateNewButton from '@/apps/facilityAndProject/CreateNewButton.vue';

    export default {
        directives: {
            'require-can-edit-code': requireCanEditCode
        },
        components: {
            CreateNewButton,
            FacilityAndProjectMainContainer: ViewBaseFacilityAndProject,
            ProjectVirtualList
        },
        data() {
            return {
                showSearchHelpDialog: true,
                filter: '',
                filterDisplayValue: '',
                codeSetName: null,
                projects: [],
                loading: false,
                columns: [
                    { label: 'Name', type: 'STRING', valueIdx: 0 },
                    { label: 'Description', type: 'STRING', valueIdx: 1 },
                    { label: 'Is valid', type: 'BOOL', valueIdx: 2 }
                ]
            };
        },
        computed: {
            rows() {
                if (this.projects) {
                    return this.projects.map(c => ({ id: encodeIdBase64('Code', c.Id), values: [c.Name, c.Description, true] }));
                } else return [];
            }
        },
        watch: {
            async filter() {
                if (this.filter.length >= 3) {
                    this.filterDisplayValue = `Name like "%${this.filter.trim()}%"`;
                    this.loadProjects();
                }
            }
        },
        async mounted() {
            this.codeSetName = (await getCodeSets(this, 'Project'))[0].name;
        },
        methods: {
            async loadProjects() {
                this.loading = true;
                this.showSearchHelpDialog = false;
                this.projects = (await genericViewQueryAsText(this, `
                    FROM Project
                    SELECT Id, Name, Description
                    WHERE IsValid=true AND Name LIKE @filter
                `, [{ name: '@filter', value: `%${this.filter.trim()}%` }])).data;
                this.loading = false;
            },
            newProject() {
                this.$router.push({ name: 'CreateNewProject' });
            },
            cancelNew() {
                this.$router.push({ name: 'ProjectList' });
            },
            async refreshProjects() {
                this.$router.push({ name: 'ProjectList' });
                await this.loadProjects();
            }
        }
    };
</script>
